export const clearAllNotifications=()=>{
    return {
        type:"clearAllNotifications"
    }
} 

export const setNotifications=(notifications)=>{
    return {
        type:"setNotifications",
        notifications:notifications,
    }
} 